import React from 'react';
import { getBaseUrl } from '../config/api';

const AdjuntosList = ({ adjuntos }) => {
    const baseUrl = getBaseUrl();
    return (
        <div>
            <h3>Archivos adjuntos</h3>
            <ul style={{ listStyle: 'none', padding: 0 }}>
                {adjuntos.map((archivo, index) => {
                    const url = `${baseUrl}/uploads/tickets/${archivo.nombre_archivo}`; // ajusta según tu backend
                    const isImage = archivo.tipo_archivo.startsWith('image/');

                    return (
                        <li key={index} style={{ marginBottom: '12px' }}>
                            <a href={url} target="_blank" rel="noopener noreferrer">
                                     {archivo.nombre_archivo}
                                </a>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default AdjuntosList;
